import { Controller } from '@hotwired/stimulus';

export class TextareaController extends Controller {
  static targets = [ 'autosize', 'input' ];

  autosizeValue(value) {
    if (value instanceof Event) {
      this.autosizeTarget.dataset.value = value.target.value;

      return;
    }

    this.autosizeTarget.dataset.value = value;
  }

  connect() {
    this.autosizeValue(this.inputTarget.value);
  }
}
